
import { defineComponent, ref, watchEffect, computed } from "vue";
import { ErrorMessage, Field } from "vee-validate";
import { useStore } from "vuex";
import Editor from "@tinymce/tinymce-vue";
import DropDownSection from "@/components/sections/DropDownSections.vue";
import IrbGptSection from "@/components/sections/IrbGptSection.vue";

interface IStep3 {
  q3_1: string;
  q3_2: string;
}

export default defineComponent({
  name: "step-2",
  components: {
    ErrorMessage,
    Field,
    Editor,
    DropDownSection,
    IrbGptSection,
  },
  setup() {
    const store = useStore();
    const listDropDownSections = [
      {
        title: "Information",
        descriptions: [{ description: " Some Information" }],
      },
    ];
    const step3 = ref<IStep3>({
      q3_1: "",
      q3_2: "",
    });

    const submitButtonRef = ref<null | HTMLButtonElement>(null);

    const submit = () => {
      if (!submitButtonRef.value) {
        return;
      }
    };

    const currentEditorToken = computed(() => {
      return store.getters.currentEditorToken;
    });

    watchEffect(() => {
      const data = store.getters.currentSubject;
      if (data === null || data.data === undefined) return;
      step3.value.q3_1 =
        data.data.inclusionCriterial != null
          ? data.data.inclusionCriterial
          : "";
      step3.value.q3_2 =
        data.data.exclusionCriterial != null
          ? data.data.exclusionCriterial
          : "";
    });

    return {
      submit,
      submitButtonRef,
      step3,
      listDropDownSections,
      currentEditorToken,
    };
  },
});
